<template>
    <div>
        <a-modal
            :visible="visible"
            :title="$t('program.import_program_details_drawer.title' /* 新增导入任务 */)"
            :width="500"
            :maskClosable="false"
            :confirm-loading="confirmLoading"
            @ok="handleOk"
            @cancel="handleCancel"
        >
            <a-form :form="form">
                <a-form-item>
                    <a-input type="hidden" v-decorator="['task_id']" />
                </a-form-item>
                <a-form-item :label="$t('program.import_program_details_drawer.upload_file' /* 上传文件 */)">
                    <a-upload
                        :action="uploadUrl"
                        :data="{ type: 1 }"
                        :headers="uploadHeaders"
                        :before-upload="beforeUpload"
                        :file-list="fileList"
                        @change="handleFileChange"
                        @remove="handleFileRemove"
                    >
                        <a-input
                            type="hidden"
                            v-decorator="['warm_template_url', { rules: [{ required: true, message: $t('program.import_program_details_drawer.please_upload_file' /* 请上传导入数据 */) }] }]"
                        />
                        <a-button style="width: 150px" type="primary">
                            <a-icon type="plus"></a-icon>
                            {{ $t('program.import_program_details_drawer.upload_data' /* 上传导入数据 */) }}
                        </a-button>
                    </a-upload>
                    <template slot="extra">
                        <div style="color: #f00">{{ $t('program.import_program_details_drawer.upload_tips' /* 请上传后缀为xlsx的文件 */) }}</div>
                        <div class="flex x-left">
                            <a class="mr20" style="color: #0a73bb" href="https://meetingfiles-beijing.oss-cn-beijing.aliyuncs.com/download/program_export_template.xlsx" target="_blank">
                                {{ $t('program.import_program_details_drawer.download_template' /* 下载导入模板 */) }}
                            </a>
                            <a style="color: #0a73bb" href="https://meetingfiles-beijing.oss-cn-beijing.aliyuncs.com/download/czsm.pdf" target="_blank">
                                {{ $t('program.import_program_details_drawer.download_instructions' /* 下载操作说明 */) }}
                            </a>
                        </div>
                    </template>
                </a-form-item>
            </a-form>
        </a-modal>
    </div>
</template>
<script>
import userApi from '@/request/apiList';

export default {
    name: 'AddImportProgramModal',
    data() {
        return {
            visible: false,
            confirmLoading: false,
            form: this.$form.createForm(this),
            uploadUrl: userApi.uploadImage,
            fileList: [],
            uploadHeaders: {}
        };
    },
    methods: {
        show(task_id) {
            this.visible = true;
            this.$nextTick(() => {
                task_id && this.form.setFieldsValue({ task_id: task_id });
            });
        },
        /**
         * 确定
         */
        handleOk() {
            this.form.validateFields((err, values) => {
                if (!err) {
                    this.confirmLoading = true;
                    this.$request
                        .post({ url: 'saveAddImportTask', data: values })
                        .then(res => {
                            this.$message.success(this.$t('program.import_program_details_drawer.add_success' /* 添加成功 */));
                            this.$emit('refresh');
                            this.visible = false;
                        })
                        .finally(() => {
                            this.confirmLoading = false;
                        });
                }
            });
        },
        /**
         * 取消
         */
        handleCancel() {
            this.form.resetFields();
            this.visible = false;
        },
        /**
         * ## 文件上传前
         */
        beforeUpload(file) {
            return new Promise((resolve, reject) => {
                // 检查文件大小是否超过500MB
                const isLt500M = file.size / 1024 / 1024 < 500;
                if (!isLt500M) {
                    this.$message.error(this.$t('program.import_program_details_drawer.limit_500' /* 文件大小不能超过500MB! */));
                    return;
                }

                // // 获取当前上传的文件后缀
                // let suffix = file.name.split('.');
                // suffix = suffix[suffix.length - 1].toLowerCase();

                // // 取后台上传的后缀配置
                // let fileType = ['xlsx', 'pdf'];
                // // 获取当前上传的文件后缀
                // if (!fileType.includes(suffix)) {
                //     this.$message.error(`请上传后缀为${fileType}的格式`);
                //     return;
                // }
                return resolve(true);
            });
        },
        /**
         * ## 上传文件后
         */
        handleFileChange(info) {
            let tempFileList = [...info.fileList];
            tempFileList = tempFileList.slice(-1);
            tempFileList = tempFileList.map(file => {
                if (file.response) {
                    let { code, data } = file.response;
                    if (code == 200) {
                        // 上传成功
                        this.form.setFieldsValue({
                            warm_template_url: data.relative_path
                        });
                    }
                }
                return file;
            });
            this.fileList = tempFileList;
        },
        /**
         * ## 删除文件
         */
        handleFileRemove(file) {
            return new Promise((resolve, reject) => {
                this.form.setFieldsValue({ warm_template_url: '' });
                this.fileList = [];
                return resolve(true);
            });
        }
    },
    mounted() {
        this.uploadHeaders['meetingID'] = this.$route.params.meeting_id;
        this.uploadHeaders['mid'] = this.$route.params.meeting_id;
        this.uploadHeaders['auth'] = this.$storage.get('token');
    }
};
</script>
<style lang="less" scoped>
</style>